import { ClassAttributes, HTMLAttributes } from "react";
import { SideFooter } from "./Footer";
import { NavMenuTrial } from "./NavMenuTrial";
import { Interpolation, Theme, css } from "@emotion/react";

export const SideBarTrial = ({
  ...props
}: ClassAttributes<HTMLElement> &
  HTMLAttributes<HTMLElement> & {
    css?: Interpolation<Theme>;
  }) => {
  return (
    <aside
      css={css`
        position: sticky;
        top: var(--header-height);
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 24px;
        height: calc(100vh - 120px);
        width: var(--sidebar-width);
        margin-right: var(--sidebar-margin);
      `}
      {...props}
    >
      <NavMenuTrial showSubMenu />
      <SideFooter />
    </aside>
  );
};
